import FormContext from './formContext'
export default FormContext.Consumer
